// Fonts declaration

const fontNormal = `'TradeGothicLTCom', -apple-system, BlinkMacSystemFont,
'avenir next', avenir, 'helvetica neue', helvetica, ubuntu, roboto, noto,
arial, sans-serif`;

const fontSemi = `'TradeGothicLTCom-Cn18', -apple-system, BlinkMacSystemFont,
'avenir next', avenir, 'helvetica neue', helvetica, ubuntu, roboto, noto,
arial, sans-serif`;

const fontBold = `'TradeGothicLTCom-BdCn20', -apple-system, BlinkMacSystemFont,
'avenir next', avenir, 'helvetica neue', helvetica, ubuntu, roboto, noto,
arial, sans-serif`;

export default {
  fontNormal,
  fontSemi,
  fontBold,
};
